module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/tv.2d442682.jpg";